import { render, staticRenderFns } from "./regions-selection.vue?vue&type=template&id=d8fed828"
import script from "./regions-selection.vue?vue&type=script&lang=ts"
export * from "./regions-selection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports